
export const ADD_CART_LIST = 'ADD_CART_LIST'
export const REMOVE_FROM_CART_LIST = 'REMOVE_FROM_CART_LIST'
export const INIT_CART = 'INIT_CART'
export const ADD_CHECK_LIST = 'ADD_CHECK_LIST'
export const REMOVE_ALL_CHECKLIST_FROM_CART_LIST = 'REMOVE_ALL_CHECKLIST_FROM_CART_LIST'
export const ADD_ORDER = 'ADD_ORDER'
export const CLIENT_INFO = 'CLIENT_INFO'
export const LOGIN_STATE_UPDATE = 'LOGIN_STATE_UPDATE'
export const CLIENT_INFO_UPDATE = 'CLIENT_INFO_UPDATE'
export const ENTERPRISE_INFO_UPDATE = 'ENTERPRISE_INFO_UPDATE'
export const INVOICETITLE_INFO_UPDATE = 'INVOICETITLE_INFO_UPDATE'
export const EXPRESSADDRESS_UPDATE = 'EXPRESSADDRESS_UPDATE'
export const DELETE_CART_LIST = 'DELETE_CART_LIST'
export const INVOICE_TITLE = 'INVOICE_TITLE'
export const MYORDER_UPDATE = 'MYORDER_UPDATE'
export const CANCEL_ORDER_FROM_WAITPAID_ORDER = 'CANCEL_ORDER_FROM_WAITPAID_ORDER'
export const ADD_WAITPAID_ORDER = 'ADD_WAITPAID_ORDER'
export const ADD_WAITDELIVER_ORDER_FROM_WAITPAID_ORDER = 'ADD_WAITDELIVER_ORDER_FROM_WAITPAID_ORDER'
export const ADD_COMMENT_FROM_WAITCOMMENT = 'ADD_COMMENT_FROM_WAITCOMMENT'
export const GENE_SEARCH_RESULT = 'GENE_SEARCH_RESULT'
export const HARD_GENE_INFO = 'HARD_GENE_INFO'
export const POPUP_TEXT_RESULT = 'POPUP_TEXT_RESULT'
export const FIND_FILTERS = 'FIND_FILTERS'
export const FINDER_RESULT_TOTAL = 'FINDER_RESULT_TOTAL'
export const INIT_MESSAGE = 'INIT_MESSAGE'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const INVOICE_ADDRESS = 'INVOICE_ADDRESS'
export const MERCHDISEGROUP_UPDATE = 'MERCHDISEGROUP_UPDATE'
export const ROUTER_STORE = 'ROUTER_STORE'
export const QUERY_PARAMS_STORE = 'QUERY_PARAMS_STORE'
export const QUERY_TOTAL = 'QUERY_TOTAL'
export const CUST_DATA = 'CUST_DATA'
export const FINDER_FLAG = 'FINDER_FLAG'
export const FINDER_SEARCH_TEXT = 'FINDER_SEARCH_TEXT'
export const SET_SECPROMOTION_INFO = 'SET_SECPROMOTION_INFO'
export const UPDATE_SECPROMOTION_INFO = 'UPDATE_SECPROMOTION_INFO'
export const SETCONTRCTINfFOBOX = 'SETCONTRCTINfFOBOX'
export const UPDATE_DEPARTMENT_INFO = 'UPDATE_DEPARTMENT_INFO'
export const UPDATE_SHOWBILLINFO = 'UPDATE_SHOWBILLINFO'
export const SET_SHOW_PRODUCT_IMAGE = 'SET_SHOW_PRODUCT_IMAGE'
export const COMBINE_CART_LIST = 'COMBINE_CART_LIST'
export const UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE = 'UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE'
export const UPDATE_CART_CONTENT = 'UPDATE_CART_CONTENT'
export const UPDATE_CHOSEN_RESEARCH_INDEX = 'UPDATE_CHOSEN_RESEARCH_INDEX'
export const UPDATE_CHOSEN_RESEARCH_MEMBER = 'UPDATE_CHOSEN_RESEARCH_MEMBER'
export const UPDATE_RESEARCHGROUP_MEMBER_MAP = 'UPDATE_RESEARCHGROUP_MEMBER_MAP'
export const UPDATE_RESEARCHGROUP_SET = 'UPDATE_RESEARCHGROUP_SET'
export const REMOVE_ALL_FROM_CART_LIST = 'REMOVE_ALL_FROM_CART_LIST'
export const UPDATE_CUST_REMARK = 'UPDATE_CUST_REMARK'
export const UPDATE_CUST_REMARK1 = 'UPDATE_CUST_REMARK1'
export const UPDATE_RESEARCHGROUP_ORDER_MAP = 'UPDATE_RESEARCHGROUP_ORDER_MAP'
export const UPDATE_CHOSEN_ORDER = 'UPDATE_CHOSEN_ORDER'
export const UPDATE_CHOSEN_MEMBER = 'UPDATE_CHOSEN_MEMBER'
export const UPDATE_TOTAL_APPROVE_AMOUNT = 'UPDATE_TOTAL_APPROVE_AMOUNT'
export const UPDATE_PROGRESSINFO = 'UPDATE_PROGRESSINFO'
export const SET_CURRENT_WAITPAY_ORDER = 'SET_CURRENT_WAITPAY_ORDER'
export const SET_CART_LIST = 'SET_CART_LIST'
export const SET_CURRENT_MYORDER_TABINDEX = 'SET_CURRENT_MYORDER_TABINDEX'
export const UPDATE_WEAPP_MYORDERS = 'UPDATE_WEAPP_MYORDERS'
export const ORDER_MATERIAL_INFO = 'ORDER_MATERIAL_INFO'
export const REASSEMBLE_ORDER_MATERIAL_INFO = 'REASSEMBLE_ORDER_MATERIAL_INFO'
export const MATERIALDETAIL_ORDERMATERIALID = 'MATERIALDETAIL_ORDERMATERIALID'

export const UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET = 'UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET'



// WEBPACK FOOTER //
// ./src/store/mutation-type.js